var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48925 0C7.75498 0 7.88784 0 8.15357 0C8.81789 0 9.21649 0.531459 9.61508 0.930053C9.74795 1.06292 9.74795 1.06292 9.88081 1.19578C11.4752 2.79016 13.0696 4.38453 14.7968 6.11177C14.9297 6.24464 15.1954 6.3775 15.3283 6.64323C15.594 6.90896 15.9926 7.30756 15.9926 7.83902C15.9926 8.23761 15.9926 8.50334 15.9926 8.90193C15.9926 9.0348 15.9926 9.0348 15.9926 9.16766C15.9926 12.3564 15.9926 15.4123 15.9926 18.6011C15.9926 18.9996 15.8597 19.3982 15.594 19.7968C15.1954 20.1954 14.7968 20.4612 14.2653 20.4612C14.1325 20.4612 13.9996 20.4612 13.9996 20.4612C10.1465 20.4612 6.29347 20.4612 2.30753 20.4612C1.11175 20.4612 0.0488281 19.3982 0.0488281 18.2025C0.0488281 12.8879 0.0488281 7.57329 0.0488281 2.2587C0.0488281 1.99297 0.0488283 1.72724 0.181693 1.46151C0.181693 0.664323 0.713151 0 1.77607 0H1.90893C3.63617 0 5.49628 0 7.22352 0C7.35638 0 7.48925 0 7.48925 0Z",
    fill: "#6572E4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.b62bd21e1a6d623405a6a5e4a56d5ee6.svg";
export { ForwardRef as ReactComponent };